import { useReducer } from 'react';
import { createContainer } from 'react-tracked';

const initialState = {
    isError: false,
    isStatusModalOpen: false,
    isSuccess: false,
    message: '',
    refresh: false,
    title: '',
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'closeStatusModal': {
            return {
                ...state,
                isStatusModalOpen: false,
            };
        }
        case 'openStatusModal': {
            return {
                ...action.payload,
                isStatusModalOpen: true,
            };
        }
        default: {
            return state;
        }
    }
};

const useValue = () => useReducer(reducer, initialState);

const {
    Provider: StatusModalProvider,
    useTrackedState: useStatusModalState,
    useUpdate: useStatusModalDispatch,
} = createContainer(useValue);

const useStatusModalContext = () => {
    const dispatch = useStatusModalDispatch();
    const state = useStatusModalState();

    const openStatusModal = (payload) => {
        dispatch({ type: 'openStatusModal', payload });
    };

    const closeStateModal = () => {
        dispatch({ type: 'closeStatusModal' });
    };

    return {
        state,
        openStatusModal,
        closeStateModal,
    };
};

export { StatusModalProvider, useStatusModalContext };
